// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__druhM","container":"modal_container___GUSW"};